import moment from 'moment';
import { Base } from './_base.model';

export class Invitation extends Base {
  id: string;
  type: string;
  bureau_id: string;
  meeting_types: string[];
  topics: string[];
  subject: string;
  bgcolor: string;
  file: string;
  files: any;
  active: boolean;
  // null = Default (CKEditor); 'unlayer' / 'text' = explicit choice. Allow null
  // so we can normalize the DB's missing-column case to "Default" before the
  // radios bind (otherwise none of them are checked and no editor renders).
  editor?: string | null;
  html?: string;
  unlayer_design: any;
  active_at: Date;
  expire_at: Date;
  created_at: Date;
  attachments: InvitationAttachment[];

  constructor() {
    super();
    this.html = '';
  }

  deserialize(obj: any) {
    Object.assign(this, obj);
    if (this.active_at) {
      this.active_at = moment(this.active_at).toDate();
    }
    if (this.expire_at) {
      this.expire_at = moment(this.expire_at).toDate();
    }
    return this;
  }
}

export class InvitationAttachment {
  id: number;
  invitation_id: string;
  file: string;
  filename: string;
  extention: string;
  mimetype: string;
  rank: number;
}
